import script from "./MainMenuVertical.vue?vue&type=script&setup=true&lang=js"
export * from "./MainMenuVertical.vue?vue&type=script&setup=true&lang=js"

import "./MainMenuVertical.vue?vue&type=style&index=0&id=2423b308&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2423b308"]])

export default __exports__